<div class="container bg-whitesmoke py-4">
  <app-breadcrumb></app-breadcrumb>
<div class="container-form bg-whitesmoke py-4">

  <div class="row">
    <div class="col-12">
      <mat-card class="shadow-sm rounded listing-form-container">
        <mat-card-header class="form-header">
          <mat-card-title class="form-title">
            <mat-icon class="title-icon">{{ editingItem ? 'edit' : 'add_circle' }}</mat-icon>
            {{ editingItem ? 'Edit' : 'Create' }} {{ typeMeta[activeType].singular || 'Item' }}
          </mat-card-title>
        </mat-card-header>
        
        <mat-card-content class="form-content-wrapper">
          <form [formGroup]="listingForm" (ngSubmit)="onSubmit()" class="form-content">
            <div class="form-grid">
              <div class="form-column">
                <!-- NAME / TITLE FIELD -->
                <mat-form-field appearance="outline" class="custom-form-field w-100">
                  <mat-label class="field-label">
                    {{
                      activeType === 'product' ? 'Product Name' :
                      activeType === 'service' ? 'Service Title' :
                      activeType === 'events' ? 'Event Title' :
                      activeType === 'charity' ? 'Charity Title' :
                      activeType === 'projects' ? 'Project Title' : 'Title'
                    }}
                  </mat-label>
                  <input matInput formControlName="nameOrTitle" required class="field-input">
                </mat-form-field>

                <!-- Project-specific fields -->
                <div *ngIf="activeType === 'projects'" class="project-specific-fields mt-3">
                  <mat-form-field appearance="outline" class="custom-form-field w-100 mb-3">
                    <mat-label class="field-label">Project Type</mat-label>
                    <input matInput formControlName="projectType" placeholder="e.g. Digital Marketing, Web Development" class="field-input">
                  </mat-form-field>
                  
                  <mat-form-field appearance="outline" class="custom-form-field w-100 mb-3">
                    <mat-label class="field-label">Status</mat-label>
                    <mat-select formControlName="status" class="field-input">
                      <mat-option *ngFor="let status of statusOptions" [value]="status">{{ status | titlecase }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  
                  <mat-form-field appearance="outline" class="custom-form-field w-100 mb-3">
                    <mat-label class="field-label">YouTube Video Link</mat-label>
                    <input matInput formControlName="youtubeId" placeholder="Paste YouTube video URL or ID" class="field-input">
                  </mat-form-field>
                  
                  <mat-form-field appearance="outline" class="custom-form-field w-100">
                    <mat-label class="field-label">Description</mat-label>
                    <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="8" class="field-input"></textarea>
                  </mat-form-field>
                </div>

                <!-- DESCRIPTION FIELD for other types -->
                <mat-form-field *ngIf="activeType !== 'reviews' && activeType !== 'events' && activeType !== 'charity' && activeType !== 'projects'"
                  appearance="outline" class="custom-form-field w-100">
                  <mat-label class="field-label">Description</mat-label>
                  <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="4" class="field-input"></textarea>
                  <button mat-icon-button matSuffix type="button" (click)="generateDescriptionOnly()" color="primary"
                    [disabled]="generatingAIContent" matTooltip="Generate Description Only" class="ai-generate-btn">
                    <mat-icon *ngIf="!generatingAIContent">auto_awesome</mat-icon>
                    <mat-spinner *ngIf="generatingAIContent" diameter="16"></mat-spinner>
                  </button>
                </mat-form-field>

                <!-- REVIEW FIELDS -->
                <mat-form-field *ngIf="activeType === 'reviews'" appearance="outline" class="custom-form-field w-100">
                  <mat-label class="field-label">Reviewer Name</mat-label>
                  <input matInput formControlName="reviewerName" class="field-input" />
                </mat-form-field>
                
                <mat-form-field *ngIf="activeType === 'reviews'" appearance="outline" class="custom-form-field w-100">
                  <mat-label class="field-label">Review</mat-label>
                  <textarea matInput formControlName="review" cdkTextareaAutosize cdkAutosizeMinRows="3" class="field-input"></textarea>
                </mat-form-field>
              </div>

              <div class="form-column">
                <!-- PRICE AND CURRENCY -->
                <mat-form-field *ngIf="activeType !== 'reviews' && activeType !== 'charity'" appearance="outline" class="custom-form-field w-100">
                  <mat-label class="field-label">Price</mat-label>
                  <input matInput type="number" formControlName="price" class="field-input">
                </mat-form-field>
                
                <mat-form-field *ngIf="activeType !== 'reviews' && activeType !== 'charity'" appearance="outline" class="custom-form-field w-100">
                  <mat-label class="field-label">Currency</mat-label>
                  <mat-select formControlName="currency" class="field-input">
                    <mat-option value="INR">INR</mat-option>
                    <mat-option value="USD">USD</mat-option>
                    <mat-option value="EUR">EUR</mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- FEATURES/AMENITIES SECTIONS -->
                <div *ngIf="activeType === 'projects'" class="features-form-section">
                  <label class="form-section-label">
                    <mat-icon class="section-icon">view_list</mat-icon>
                    Amenities
                  </label>
                  <div formArrayName="amenities">
                    <div *ngFor="let amenity of amenitiesArray.controls; let i = index" class="feature-input-group">
                      <mat-form-field appearance="outline" class="flex-grow-1 custom-form-field">
                        <mat-label class="field-label">Amenity {{ i + 1 }}</mat-label>
                        <input matInput [formControlName]="i" class="field-input">
                      </mat-form-field>
                      <button type="button" mat-icon-button color="warn" (click)="removeAmenity(i)" class="remove-feature-btn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <button type="button" mat-stroked-button color="primary" (click)="addAmenity()" [disabled]="amenitiesArray.length >= maxFeaturesAllowed" class="add-feature-btn">
                    <mat-icon>add</mat-icon>
                    Add Amenity
                  </button>
                  <div class="error-message" *ngIf="amenityErrorMessage">{{ amenityErrorMessage }}</div>
                </div>

                <div *ngIf="activeType !== 'reviews' && activeType !== 'charity' && activeType !== 'projects'" class="features-form-section">
                  <label class="form-section-label">
                    <mat-icon class="section-icon">star</mat-icon>
                    Key Features
                  </label>
                  <div formArrayName="features">
                    <div *ngFor="let feature of featuresArray.controls; let i = index" class="feature-input-group">
                      <mat-form-field appearance="outline" class="flex-grow-1 custom-form-field">
                        <mat-label class="field-label">Feature {{ i + 1 }}</mat-label>
                        <input matInput [formControlName]="i" class="field-input">
                      </mat-form-field>
                      <button type="button" mat-icon-button color="warn" (click)="removeFeature(i)" class="remove-feature-btn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <button type="button" mat-stroked-button color="primary" (click)="addFeature()" [disabled]="featuresArray.length >= maxFeaturesAllowed" class="add-feature-btn">
                    <mat-icon>add</mat-icon>
                    Add Feature
                  </button>
                  <div class="error-message" *ngIf="featureErrorMessage">{{ featureErrorMessage }}</div>
                </div>

                <!-- IMAGES SECTION -->
                <div class="images-form-section" *ngIf="activeType !== 'reviews'">
                  <label class="form-section-label">
                    <mat-icon class="section-icon">photo_library</mat-icon>
                    Images (first is cover)
                  </label>
                  <input type="file" (change)="onFileChange($event)" multiple accept="image/*" class="file-input">
                  
                  <div class="image-previews" *ngIf="imagePreviews.length > 0">
                    <div *ngFor="let preview of imagePreviews; let i = index" class="image-preview-item">
                      <img [src]="preview" alt="Preview" class="preview-image">
                      <button type="button" class="remove-btn" (click)="removeImage(i)">×</button>
                      <span *ngIf="i === 0" class="cover-badge">Cover</span>
                    </div>
                  </div>
                  
                  <div *ngIf="uploadProgress.length > 0" class="upload-progress">
                    <div *ngFor="let p of uploadProgress; let i = index" class="progress-item">
                      <small class="progress-text">Image {{ i+1 }}: {{ p }}%</small>
                      <mat-progress-bar mode="determinate" [value]="p" class="progress-bar"></mat-progress-bar>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- FORM ACTIONS -->
            <div class="modal-actions">
              <button type="button" mat-stroked-button class="cancel-btn" (click)="goBack()">Cancel</button>
              <button type="submit" mat-raised-button color="primary" [disabled]="creating || listingForm.invalid" class="submit-btn">
                <div class="d-flex align-items-center">
                  <mat-spinner *ngIf="creating" diameter="20" class="me-2"></mat-spinner>
                  <mat-icon *ngIf="!creating" class="me-2">{{ editingItem ? 'save' : 'add' }}</mat-icon>
                  <span>{{ creating ? 'Processing...' : (editingItem ? 'Save Changes' : 'Create') }}</span>
                </div>
              </button>
            </div>
            
            <!-- Error Display -->
            <div class="ai-error" *ngIf="aiError">
              <mat-icon class="error-icon">error</mat-icon>
              <span>{{ aiError }}</span>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
</div>